module.exports = __webpack_public_path__ + "img/icon／4.d2d283b7.png";